'use strict';

angular.module('portal.i18n')
    .component('selectLanguage', {
        controller: 'I18nSelectLanguageController',
        templateUrl: 'js/modules/i18n/components/select-language/template.html',
    });
